<script>
import feather from 'feather-icons'
import AppHeaderLinks from './AppHeaderLinks.vue'

export default {
  components: {
    AppHeaderLinks,
  },
  data() {
    return {
      isOpen: false,
      theme: '',
    }
  },

  created() {
    this.theme = 'dark'
  },
  mounted() {
    feather.replace()
    this.theme = 'dark'
  },
  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen
    },
  },
  updated() {
    feather.replace()
  },
}
</script>

<template>
  <nav id="nav" class="sm:container sm:mx-auto">
    <!-- Header start -->
    <div class="z-10 max-w-screen-lg xl:max-w-screen-xl block sm:flex sm:justify-between sm:items-center my-6">
      <!-- Header menu links and small screen hamburger menu -->
      <div class="flex justify-between items-center px-4 sm:px-0">
        <!-- Header logos -->
        <div>
          <router-link to="/">
            <img src="@/assets/images/mfd-logo.png" class="w-32 sm:w-40" alt="MFD Solutions" />
          </router-link>
        </div>

        <!-- Mobile hamburger menu toggle -->
        <button
          @click="toggleMenu"
          class="sm:hidden text-primary-light p-2"
          aria-label="Toggle Menu"
        >
          <i :data-feather="isOpen ? 'x' : 'menu'"></i>
        </button>
      </div>

      <!-- Header links -->
      <AppHeaderLinks :isOpen="isOpen" @close="isOpen = false" />

      <!-- Header right section buttons -->
      <div class="hidden sm:flex justify-between items-center flex-col md:flex-row">
        <router-link
          to="/contact"
          class="font-display uppercase tracking-wider clip-corner-sm px-5 py-2.5 shadow-glow hover:shadow-glow-lg bg-brand-600 hover:bg-brand-700 text-white font-semibold duration-300"
          aria-label="Contact Us"
        >
          Contact Us
        </router-link>
      </div>
    </div>

    <!-- Hazard stripe divider -->
    <div class="hazard-stripe"></div>
  </nav>
</template>

<style scoped>
#nav a.router-link-exact-active {
  @apply text-brand-700;
  @apply dark:text-brand-400;
  @apply font-medium;
}
</style>
